import { render, staticRenderFns } from "./indicator-detail.vue?vue&type=template&id=3c35d432&scoped=true&"
import script from "./indicator-detail.vue?vue&type=script&lang=ts&"
export * from "./indicator-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c35d432",
  null
  
)

export default component.exports